import { render, staticRenderFns } from "./PersonalesConsultaBuroNew.vue?vue&type=template&id=ed5e6042&lang=html&"
import script from "./PersonalesConsultaBuroNew.vue?vue&type=script&lang=js&"
export * from "./PersonalesConsultaBuroNew.vue?vue&type=script&lang=js&"
import style0 from "./PersonalesConsultaBuroNew.vue?vue&type=style&index=0&id=ed5e6042&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports